// sidebar-left.config.ts

export type DropdownKey = 'regioni' | 'province' | 'enti' | 'reti' | 'dateRange';

export type DropdownConfig = {
  key: DropdownKey;
  title: string;
  stateSelector?: 'selectedRegion' | 'selectedProvince' | 'selectedEnte' | 'selectedRete' | 'dateRange';
};

export const SIDEBAR_DROPDOWNS: DropdownConfig[] = [
  { key: 'reti', title: 'Seleziona Reti', stateSelector: 'selectedRete' },
  { key: 'regioni', title: 'Seleziona Regioni', stateSelector: 'selectedRegion' },
  { key: 'province', title: 'Seleziona Province', stateSelector: 'selectedProvince' },
  { key: 'enti', title: 'Seleziona Enti', stateSelector: 'selectedEnte' },
  { key: 'dateRange', title: 'Intervallo date', stateSelector: 'dateRange' },
];
